import React from "react";
import "./styles.css";
import { useNavigate } from "react-router-dom";
import { EditModelIcon, DeleteIcon, ArrowDownIcon } from "../../../Assets/images/svgs";
import { ellipsisify } from "../../../Library/helpers";
import { Spinner, Switch, Tooltip, useToast } from "@chakra-ui/react";
import { getLocalisedDate, getLocalisedTime } from "../../../Library/datetime";
import { updateAlert } from "../../../APIs";

const DetailBar = ({ data = [], config, showEditDelete = false, handleEditClick = () => {}, handleDelete = () => {}, search, headers, isGeofence, handleSorting, toggleGeofence, geofences }) => {
  const navigate = useNavigate();
  const Toast = useToast();
  const [sortConfig, setSortConfig] = React.useState({ key: "", direction: "asc" });
  const [showTooltip, setShowTooltip] = React.useState(null);
  const [showSwitchLoader, setShowSwitchLoader] = React.useState(null);

  const renderAlertDetails = (config, obj) => {
    return config.map(({ type, key, label, linkText, subKey }) => {
      if (type === "kv") {
        return (
          <div className="detail-bar-kv-box detail-bar-box" key={key}>
            <Tooltip label={(`${((obj[key] || obj[subKey]) || "-")}`).length > 20 ? ((obj[key] || obj[subKey]) || "-") : ""}>
              <span className="detail-bar-val">{ellipsisify(`${((obj[key] || obj[subKey]) || "-")}`, 20)}</span>
            </Tooltip>
          </div>
        );
      }
      if (type === "link") {
        return (
          <div className="detail-bar-link-cnt detail-bar-box" key={key}>
            <span className="detail-bar-link" onClick={() => navigate("")}>
              {linkText}({obj[key]})
            </span>
          </div>
        );
      }

      if (type === "ts") {
        return (
          <div className="detail-bar-kv-box detail-bar-box" key={key}>
            <span className="detail-bar-key">
              {obj[key] ? (
                <div className="date-container">
                  <p>{getLocalisedDate(obj[key] || 0)}</p>
                  <p>{getLocalisedTime(obj[key] || 0)}</p>
                </div>
              ) : "-"}
            </span>
          </div>
        );
      }

      if (type === "geofence") {
        let fence = geofences.find(fence => fence.idx === obj.gfId);
        return (
          <div className="detail-bar-link-cnt detail-bar-box" key={key}>
            <Tooltip label={fence && fence.title.length > 15 ? fence.title : ""}>
              {fence ? `${obj.out ? "Outside" : "Inside"} ${ellipsisify(fence.title, 15)}` : "Everywhere"}
            </Tooltip>
          </div>
        );
      }

      return null;
    });
  };

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key, direction });
    if (handleSorting) handleSorting(key, direction);
  };

  const renderAlertColumns = () => {
    return (
      <div className={`detail-bar header ${!isGeofence ? "overspeed" : ""}`}>
        {headers.map((header, index) => (
          <span onClick={() => header.sort && handleSort(header.key)} className={`detail-bar-key ${header.sort ? "cursor" : (header.nm === "Manage" ? "add-spacing" : "")}`} key={index}>
            {header.nm}
            {sortConfig.key === header.key ? (
              <>
                <ArrowDownIcon className={`${sortConfig.direction === "asc" ? "rotate-arrow" : ""}`} />
              </>
            ) : null}
          </span>
        ))}
      </div>
    );
  }

  const handleGeofenceToggle = (geofence) => {
    setShowSwitchLoader(geofence.idx);
    updateAlert({ idx: geofence.idx, typ: geofence.typ, isEnabled: !geofence.isEnabled }, (err) => {
      if (err) {
        console.log(err);
        Toast({ isClosable: true, description: `Something went wrong. Please try again later`, position: "bottom", variant: "subtle", duration: 1500 });
      } else toggleGeofence(geofence);

      setTimeout(() => {
        setShowSwitchLoader(null);
      }, 0);
    });
  }

  return data && data.length ? (
    <>
      {renderAlertColumns()}
      <div className="geofence-scroll">
        {data.map((obj, index) => (
          <div className={`detail-bar ${!isGeofence ? "overspeed" : ""}`} key={index}>
            {renderAlertDetails(config, obj)}
            {
              showEditDelete ?
              <div className="detail-bar-btn-cnt detail-bar-box manage-column">
                {isGeofence ? <div className="toggle-geofence-container">
                  {showSwitchLoader === obj.idx ? <Spinner color="lightblue" /> : <>
                    <Switch isChecked={obj.isEnabled} className="toggle-geofence-switch" id="toggle-geofence" onChange={() => handleGeofenceToggle(obj)} onMouseOver={() => setShowTooltip(index)} onMouseOut={() => setShowTooltip(null)} />
                    <p className={`toggle-geofence-tooltip ${showTooltip === index ? "scale-tooltip" : ""}`}>Enable / Disable Geofence</p>
                  </>}
                </div> : null}
                <EditModelIcon className="detail-bar-icon detail-bar-edit-icon" onClick={() => handleEditClick(obj.idx)} />
                <DeleteIcon className="detail-bar-icon detail-bar-delete-icon" onClick={() => handleDelete(obj.idx, obj)} />
              </div> :
              null
            }
          </div>
        ))}
      </div>
    </>
  ) : (
    <div className="detail-bar-no-data">
      <span className="detail-bar-no-data-text">{search ? "No geofences match your search" : "You haven't added any geofences yet"}</span>
    </div>
  );
};

export default DetailBar;
